import React from 'react';
import { useIntl } from 'react-intl';
import { ArrowRight } from 'lucide-react';
import SectionGuard from '../common/SectionGuard';

const LatestProducts = ({ products = [], apiUrl = '' }) => {
  const intl = useIntl();
  const displayProducts = Array.isArray(products) ? products : [];
  const hasContent = displayProducts.length > 0;

  const learnMoreText = intl.formatMessage({
    id: 'learn.more',
    defaultMessage: 'Learn More'
  });

  return (
    <SectionGuard hasContent={hasContent} emptyMessageId="empty.section">
      <section className="bg-neutral-50 py-16 lg:py-24">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 mb-10 lg:mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#16A34A]" />
            <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#16A34A]">
              Produits
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a1628] tracking-tight">
            {intl.formatMessage({
              id: 'latest.products.title',
              defaultMessage: 'Nos produits phares'
            })}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-slate-200">
          {displayProducts.map((product, index) => {
            const imageSrc =
              apiUrl && product.image && product.image.startsWith('/')
                ? `${apiUrl}${product.image}`
                : product.image;

            return (
              <div
                key={product.id}
                className="relative group overflow-hidden bg-white min-h-[420px] md:min-h-[520px] lg:min-h-[640px]"
              >
                <div
                  className="absolute inset-0 bg-slate-300/40 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                  style={{
                    backgroundImage: `url('${imageSrc}')`,
                    backgroundPosition: 'center bottom'
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/75 via-[#0a1628]/10 to-transparent" />

                <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-10 lg:p-12">
                  <div>
                    <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#16A34A]">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <h3 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-[#0a1628] tracking-tight drop-shadow-sm">
                      {product.title}
                    </h3>
                    {product.description ? (
                      <p className="mt-3 text-slate-700 text-base md:text-lg max-w-md leading-relaxed">
                        {product.description}
                      </p>
                    ) : null}
                  </div>

                  {product.link ? (
                    <a
                      href={product.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2.5 bg-[#16A34A] text-white px-5 py-3 text-xs font-semibold uppercase tracking-[0.14em] transition-colors hover:bg-[#15803D] w-fit mt-8"
                    >
                      {learnMoreText}
                      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </a>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </SectionGuard>
  );
};

export default LatestProducts;
